import { DropdownButton, StandardButton } from '../atoms/buttons';
import { Bar,Line, Doughnut } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    LineElement,
    PointElement,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    ArcElement,
    Tooltip,
    Legend,
} from 'chart.js';

import { useState, useEffect } from 'react';
import { subMonths, format } from "date-fns";
import { nl } from 'date-fns/locale';
import { icon } from '../functions/icons';
import { SkeletonBarChart, SkeletonDoughnutChart, SkeletonLineChart } from "../atoms/skeletonloaders";
import { borderRadius } from "polished";

export function GraphComp({graph, value, title, height, dataset, period = 12, setPeriod, loadStats, statKeys, setStatKeys, options, loading, reloadPeriod}) {
   
   
    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });
    useEffect(() => {
        const handleResize = () => {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    
    const reloadPeriodNow = (id) => {
        console.log("period_id", id)
        setPeriod(id)
    }
    const periodOptions = [
        { id: 1, content: "Laatste maand", value: 1 },
        { id: 3, content: "Laatste 3 maanden", value: 3 },
        { id: 9, content: "Laatste 9 maanden", value: 9 },
        { id: 12, content: "Laatste 12 maanden", value: 12 },
    ];
      if (graph === "rapport") {
        return (
            <div data-testid={"graph-comp"} className="vertical complete-width space-between" style={{ height: `${height}px` }}>
                <div className="horizontal">
                    <p className="diagram-title" style={{ maxWidth: "50%" }}>{title}</p>
                    <div className="horizontal rapport-btn-end">
                       <DropdownButton
                            content={
                                period === 1 ? "Laatste maand" :
                                period === 3 ? "Laatste 3 maanden" :
                                period === 6 ? "Laatste 6 maanden" :
                                period === 9 ? "Laatste 9 maanden" :
                                period === 12 && "Laatste 12 maanden"
                            }
                            dropdown={periodOptions.map(o => ({
                                id: o.id,
                                content: o.content,
                                selected: o.id === period.id
                            }))}
                            classButton="rapport-dropdown-btn"
                            classContent="graph-dropdown-content"
                            optionSelected={reloadPeriodNow}
                            />
                    </div>
                </div>
                <RapportChart dataset={dataset} period={period} />
            </div>
        );
    }

    return (
         <div data-testid={"graph-comp"} className="vertical complete-width" style={{ height: "100%" }}>
      <div className="horizontal-space-between top-row-graph">
        <p className="diagram-title">{title}</p>
        <DropdownButton
          content={title || "Selecteer module"}
          dropdown={options}
          dropdownStyle={{ position: "absolute", right: "0", left: "unset" }}
          optionSelected={(id) => {

            setStatKeys(id);
            
            }}
          classButton="rapport-dropdown-btn"
          classContent="graph-dropdown-content"
        />
      </div>
      <div className="horizontal-space-between top-row-graph">
        <p className="diagram-title">{value}</p>
       <DropdownButton
            dropdownStyle={{ position: "absolute", right: "0", left: "unset" }}
            content={
                period === 3
                ? "Laatste 3 maanden"
                : period === 6
                ? "Laatste 6 maanden"
                : period === 12
                ? "Laatste 12 maanden"
                : "Selecteer periode"
            }
            dropdown={[
                { id: 3, content: "Laatste 3 maanden", selected: period === 3 },
                { id: 6, content: "Laatste 6 maanden", selected: period === 6 },
                { id: 12, content: "Laatste 12 maanden", selected: period === 12 },
            ]}
            classButton="rapport-dropdown-btn"
            classContent="graph-dropdown-content"
            optionSelected={(id) => setPeriod(id)
            }
            />
      </div>
      {(graph === "bar" && <BarChart title={title} loading={loading} period={period.value} dataset={dataset} />) ||
        (graph === "doughnut" && <NestedDoughnutChart loading={loading} />) ||
        (graph === "rapport" && <RapportChart loading={loading} dataset={dataset} period={10} />)}
    </div>
  );
}


// src/BarChart.js

ChartJS.register(
    CategoryScale,
    LinearScale,
    LineElement,
    PointElement,
    BarElement,
    Title,
    Tooltip,
    Legend,
    ArcElement
);

export const RapportChart = ({ dataset, period, loading }) => {
    console.log(dataset, "dataset in rapport chart");
    if (loading) return <SkeletonLineChart height="300px" />;
    
    const primary600 = getComputedStyle(document.documentElement).getPropertyValue('--primary-600').trim();
    const now = new Date();

    const labels = Array.from({ length: parseInt(period) }, (_, i) => {
        const date = subMonths(now, parseInt(period) - 1 - i);
        return format(date, 'MMMM', { locale: nl });
    });
    const title = dataset?.courses ? dataset.courses.map((course, index) => `${index + 1}.${course.title}`).join(", ") : "";
    const color = primary600; 
    const datasets = [{
            label: title,
            data: [...dataset.graph].reverse(),
            borderColor: color,
            backgroundColor: color,
            pointBackgroundColor: color,
            pointBorderColor: "transparent",
            pointRadius: 5,
            pointHoverRadius: 6,
            fill: false,
            borderWidth: 2,
            borderRadius: 10,
            tension: 0.1 }]
 
    
    const data = {
        labels,
        datasets
    };

    console.log("fack",data)
    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
            },
        },
        scales: {
            x: {
                grid: { display: false, drawBorder: false },
            },
            y: {
                grid: { display: false, drawBorder: false },
                beginAtZero: true,
            },
        },
    };


    return <Bar data-testid="rapport-graph" key={JSON.stringify(data)} data={data} options={options} />;
};




export const BarChart = ({dataset, period, loading,title}) => {
    const primary600 = getComputedStyle(document.documentElement).getPropertyValue('--primary-600').trim();
    const now = new Date();
    const labels = Array.from({ length: period }, (_, i) => {
    const date = subMonths(now, period - 1 - i);
    return format(date, 'MMMM', { locale: nl });
});

    const isLoading = false

  if (isLoading) {
    return <SkeletonBarChart height="300px" />;
  }
    console.log("dataset", dataset)
    // Define the data for the chart
const data = {
  labels: dataset.map((row) => row.date).reverse(),
  datasets: [
    {
      label: title,
      data: dataset.map((row) => parseInt(row.total_metric)).reverse(),
      backgroundColor: [
       
       'rgba(72,102, 136)'
      ],
      borderColor: [

        'rgba(72,102, 136)',

      ],
      borderWidth: 0
    }
  ]
};
    // Define options for the chart
    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: false,
                text: 'Monthly Sales Data',
            },
        },
        scales: {
            x: {
                // Adjust the bar width settings
              barPercentage: 0.5, // Width of the bars relative to the category width

            },
            y: {
                beginAtZero: true,
            },
        },
    };
    console.log("dashboard daata", data)
    // Render the Bar component,
    return <Bar data-testid="bar-graph" data={data} options={options} />;
};



export const DoughnutChart = ({loading}) => {
   
    const primary600 = getComputedStyle(document.documentElement).getPropertyValue('--primary-600').trim();
    const primary400 = getComputedStyle(document.documentElement).getPropertyValue('--primary-400').trim();
    // Define the data for the chart
    const data = {
        labels: ['January', 'February', 'March', 'April', 'May', "June", "July", "August", "September", "October", "November", "December"],
        datasets: [
            {
                label: 'Sales',
                data: [20, 75],
                backgroundColor: [
                    primary600,
                    primary400
                ],
                borderWidth: 1,
            },
        ],
    };

    // Define options for the chart
    const options = {
        responsive: true,
        plugins: {
            legend: {
                display: false,
                position: 'top',
            },
            title: {
                display: false,
                text: 'Monthly Sales Data',
            },
        },
        scales: {

            y: {
                beginAtZero: true,
            },
        },
    };
    // Render the Bar component
    return <Doughnut data-testid="doughnut-graph"  data={data} options={options} />;
};




export const NestedDoughnutChart = ({loading}) => {
    if (loading) return <SkeletonDoughnutChart size="300px" />;
    const primary600 = getComputedStyle(document.documentElement).getPropertyValue('--primary-600').trim();
    const primary400 = getComputedStyle(document.documentElement).getPropertyValue('--primary-400').trim();
    // Define the data for the chart
    const data = {
        labels: ['Red', 'Blue', 'Yellow', 'Green', 'Purple'],
        datasets: [
            {
                label: 'Inner Doughnut',
                data: [75, 25],
                backgroundColor: [
                    primary600,
                    "transparent"
                ],
                borderColor: [
                    "transparent",
                ],
                borderWidth: 20,
                borderRadius: 100
            },
            {
                label: 'Outer Doughnut',
                data: [60, 40],
                backgroundColor: [
                    primary400,
                    "transparent"
                ],
                borderColor: [
                    "transparent",
                ],
                borderWidth: 20,
                margin: "1rem",
                borderRadius: 100
            },
        ],
    };

    // Define options for the chart
    const options = {
        responsive: true,
        plugins: {
            legend: {
                display: false,
                position: 'top',
            },
            tooltip: {
                callbacks: {
                    label: function (tooltipItem) {
                        return `${tooltipItem.label}: ${tooltipItem.raw}`;
                    },
                },
            },
        },
        cutout: '50%', // Adjust the cutout percentage to create nested effect
    };

    // Render the Doughnut component
    return <Doughnut data-testid="nested-doughnut-chart-graph" data={data} options={options} />;
};

export default NestedDoughnutChart;